import { filter, isEmpty } from 'lodash';
const _ = { filter, isEmpty };

const CAMPUSES_ALL = [{
  value: 'SYS',
  label: 'UH All'
}, {
  value: 'MAN',
  label: 'UH Manoa'
}, {
  value: 'HIL',
  label: 'UH Hilo'
}, {
  value: 'WOA',
  label: 'UH West Oʻahu'
}, {
  value: 'UHCC',
  label: 'UHCC'
}, {
  value: 'HAW',
  label: 'Hawaiʻi CC'
}, {
  value: 'HON',
  label: 'Honolulu CC'
}, {
  value: 'KAP',
  label: 'Kapiolani CC'
}, {
  value: 'KAU',
  label: 'Kauaʻi CC'
}, {
  value: 'LEE',
  label: 'Leeward CC'
}, {
  value: 'MAU',
  label: 'Maui College'
}, {
  value: 'WIN',
  label: 'Windward CC'
}];

const CAMPUSES_UHCC = [{
  value: 'MAN',
  label: 'UH Manoa'
}, {
  value: 'HIL',
  label: 'UH Hilo'
}, {
  value: 'WOA',
  label: 'UH West Oʻahu'
}, {
  value: 'UHCC',
  label: 'UH Community Colleges'
}, {
  value: 'HAW',
  label: 'Hawaiʻi CC'
}, {
  value: 'HON',
  label: 'Honolulu CC'
}, {
  value: 'KAP',
  label: 'Kapiolani CC'
}, {
  value: 'KAU',
  label: 'Kauaʻi CC'
}, {
  value: 'LEE',
  label: 'Leeward CC'
}, {
  value: 'MAU',
  label: 'Maui College'
}, {
  value: 'WIN',
  label: 'Windward CC'
}];

/**
 * Common utility functions that can be used throughout the app
 */
export default {
  getEmptyDefault: function (value, emptyValue) {
    return _.isEmpty(value) ? (emptyValue || '-') : value;
  },
  CAMPUSES: _.filter(CAMPUSES_ALL, campus => campus.value !== 'SYS' && campus.value !== 'UHCC'),
  CAMPUSES_ALL,
  CAMPUSES_UHCC,
  CAMPUSES_UHCC_ONLY:  _.filter(CAMPUSES_ALL, campus => campus.value !== 'SYS' && campus.value !== 'MAN' && campus.value !== 'HIL' && campus.value !== 'WOA'),
  ROLE_ADMIN_DEBUG: 'irapo-maps-admdebug',
  ROLE_DEBUG: 'irapo-maps-debug',
  ROLE_STULOOKUP: 'irapo-maps-stulookup',
  ROLE_IRAPO_STAFF: 'irapo-maps-o-ods',
  SIDEBAR_WIDTH: 300,
  MOBILE_WIDTH: 820,
  MAX_SIDEBAR_WIDTH: 500
};